export default {
    "type" : "global-environment"
}